import { useEffect, useState } from 'react';
import * as S from './style';
import { UseFormRegister, UseFormSetValue, UseFormResetField } from "react-hook-form";
import axiosInstance from 'services/axiosInstance';
//components
import SearchField from '../SerarchField';
//context
import { useAuth } from 'context/AuthContext';
import { useCart } from 'context/CartContex';
//interface
import { IUser } from 'Interfaces/IUser';

export type Inputs = {
    number_ata: string,
    customer_id: number,
    user_id: number,
    payment_method_id: number,
    items: [],
    date_sale: string,
}

interface IProps {
    register: UseFormRegister<Inputs>;
    setValue: UseFormSetValue<Inputs>;
    resetField: UseFormResetField<Inputs>;
}
export default function FormsCart({
    register,
    setValue,
}: IProps) {

    const { setData } = useCart();

    //date and seller
    const UserAuthenticated = useAuth();
    const [userData, setUserData] = useState<IUser[]>([]);
    // date and seller - (Inicializar estado com valores padrão)
    const [dataInputs, setDataInputs] = useState({
        user_id: UserAuthenticated.user?.id || null,
        user_name: UserAuthenticated.user?.first_name || null,
        date_sale: new Date().toISOString().split('T')[0],
    });

    // Efeito para buscar os dados do usuário autenticado
    useEffect(() => {
        const fetch = async () => {
            try {
                const [responseUser, responseAta] = await Promise.all([
                    axiosInstance.get("/user"),
                    axiosInstance.get("/sale?per_page=1000"),
                ])
                setUserData(responseUser.data.data);

                const numbersAta = responseAta.data.data;

                const maxNumber = numbersAta.length > 0 ? Math.max(...numbersAta.map((order: any) => Number(order.number_ata || 0))) : 0;

                setValue("number_ata", (maxNumber + 1).toString());
            } catch (e) {
                console.log("erro", e);
            }
        };
        fetch();
    }, []);

    const FindUser = (idFind: string | number) => {
        const user = userData.find((user) => user.id === Number(idFind));
        setData({ seller: user })
        return user;
    }

    return (
        <S.Forms>
            <S.Section>

                {/* Data */}
                <S.FormsInputs>
                    <S.Label htmlFor="data">
                        Data
                        <span>*</span>
                    </S.Label>
                    <S.Input
                        type="date"
                        value={dataInputs.date_sale}
                        {...register("date_sale", { required: true })}
                        onChange={(e) => {
                            const value = e.target.value;
                            setDataInputs((prev) => ({ ...prev, date_sale: value }));
                            setData({ date: value || dataInputs.date_sale });
                        }}
                    />
                </S.FormsInputs>

                {/* Vendedor */}
                <S.FormsInputs>
                    <S.Label htmlFor="user_id">
                        Vendedor
                        <span>*</span>
                    </S.Label>

                    <S.Select
                        {...register("user_id", { required: true })}
                        onChange={(e) => FindUser(e.target.value)}
                    >
                        <option value={UserAuthenticated.user?.id} selected>
                            {UserAuthenticated.user?.first_name}
                        </option>
                        {userData
                            .filter((val) => val.id !== UserAuthenticated.user?.id)
                            .map((val) => (
                                <option key={val.id} value={val.id}>
                                    {val.first_name}
                                </option>
                            ))}
                    </S.Select>
                </S.FormsInputs>
            </S.Section>

            {/* Numero da venda */}
            <S.FormsInputs>
                <S.Label htmlFor='number_ata'>
                    Número da venda <span>*</span>
                </S.Label>
                <S.Input
                    id='number_ata'
                    type='text'
                    placeholder='Informe o número da venda'
                    {...register("number_ata", { required: true })}
                    onChange={(e) => setData({ number_order: e.target.value })}
                />
            </S.FormsInputs>

            {/* Cliente */}
            <S.FormsInputs>
                <S.Label htmlFor='customer_id'>
                    Informações do cliente <span>*</span>
                </S.Label>
                <SearchField
                    typeField='customer'
                    placeholder='Buscar o cliente'
                    htmlFor='cliente'
                    url='/customer'
                    onSelect={(clienteSelecionado) => {
                        setData({ customer: clienteSelecionado });
                        setValue("customer_id", clienteSelecionado.id);
                    }}
                />
            </S.FormsInputs>
        </S.Forms>
    );
}